<template>
  <button class="nf-primary-button" :type="type">
    <slot />
  </button>
</template>

<script setup>
defineProps({
  type: { type: String, default: 'button' }
})
</script>
